const localStorageKeys = {
  TOKEN_KEY: "@highnote:token",
  LOGGED_USER: "loggedUser",
};

export default localStorageKeys;
